const InputBroadCastMessage = ({ type = "text", placeholder, mudar, value }) => {
  const baseClasses =
    "w-full px-4 py-3 border border-gray-300 rounded-2xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition resize-none text-gray-800";

  if (type === "textarea") {
    return (
      <textarea
        className={`${baseClasses} min-h-[150px]`}
        placeholder={placeholder}
        onChange={mudar}
        value={value}
      />
    );
  }

  return (
    <input
      type={type}
      className={`${baseClasses}`}
      placeholder={placeholder}
      onChange={mudar}
      value={value}
    />
  );
};

export default InputBroadCastMessage;
